import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=ce95b854&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=ce95b854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce95b854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce95b854')) {
      api.createRecord('ce95b854', component.options)
    } else {
      api.reload('ce95b854', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=ce95b854&scoped=true&", function () {
      api.rerender('ce95b854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CINoTXJh4Uly/JS/comp/SearchFilterTokens.vue"
export default component.exports